import { IS_POPUP_VAR, VERSION } from "@pdfking/constants/settings"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { object_map } from "@pdfking/rfunc"
import { RecordMerge } from "@pdfking/tfunc"
import url_read_tracked from "@pdfking/workflow/utils/url_read_tracked"
import { url_query_encode } from "@pdfking/workflow/utils/urlutilities"
import { SearchselectMixin } from "./Searchselect"

export const Autocomplete = CreateRenderFunction({
  mixins: [SearchselectMixin],
  computed: {
    results() {
      return this.search_results
    },
  },
  props: {
    adminurl: "" as string,
    adminfilters: "" as string,
  },
  data: {
    hide_dropdown: true,
    loading: false,
    search_results: {} as Record<string, any>,
  },
  init() {
    this.selection = object_map(
      (i: any) => i.id,
      (i: any) => this.add_url(i),
      this.value
    )
  },
  methods: {
    add_url(i: any, score?: number) {
      return RecordMerge(i, {
        score: score || 0,
        url: `${this.adminurl + i.id}/`,
      })
    },
    search(q: string) {
      if (q.length <= 1) {
        this.search_results = {}
      } else if (!this.loading) {
        this.loading = true
        url_read_tracked(
          this.adminurl +
            "autocomplete/" +
            "?" +
            [
              url_query_encode({ [IS_POPUP_VAR]: VERSION, q }),
              this.adminfilters || "",
            ].join("&"),
          {}
        )
          .then((r: Response) => r.json())
          .then((r: any) => {
            this.loading = false
            this.search_results = RecordMerge(
              {
                [q]: {
                  id: q,
                  score: 0,
                  unicode: `<em>${q}</em>`,
                },
              },
              object_map(
                (v: any) => v.id,
                (v: any, i: number) => this.add_url(v, i + 1),
                r.objects
              )
            )
          })
      }
    },
  },
  watch: {
    query(q: string) {
      this.search(q)
    },
  },
})
